import script from "./CreateInvoiceWPOStandart.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateInvoiceWPOStandart.vue?vue&type=script&setup=true&lang=js"

import "./CreateInvoiceWPOStandart.vue?vue&type=style&index=0&id=fc8e8c2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8e8c2c"]])

export default __exports__